import { type Element } from 'html-react-parser';
import AnchorHeading from '@/components/AnchorHeader/AnchorHeader';
import { getTitleFromReactElements } from './';

const resolveDOMNode = (domNode: Element, domToReact: Function) => {
  const { children = [], attribs = {} } = domNode;
  const reactElements = domToReact(children, { trim: true });

  if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(domNode.name)) {
    const title = getTitleFromReactElements(reactElements as string | JSX.Element);
    return (
      <AnchorHeading title={title} heading={domNode.name as JSX.Element['type']}>
        {reactElements}
      </AnchorHeading>
    );
  }

  if (domNode.name === 'a') {
    const title =
      typeof attribs.title === 'string'
        ? attribs.title
        : getTitleFromReactElements(reactElements as string | JSX.Element);
    const filteredAttributes = Object.keys(attribs)
      .filter((key) => ['target', 'rel', 'href'].includes(key))
      .reduce(
        (obj, key) => ({
          ...obj,
          [key]: attribs[key],
        }),
        { title }
      );
    return <a {...filteredAttributes}>{reactElements}</a>;
  }

  return null;
};

export default resolveDOMNode;
